/* The Accelerator's own pages (Accelerator.dc.html at 1440): the home's goal, next session, actions,
   group, wins and Resources shelf, and the Actions and Group pages no board draws, which take the
   home's cards. No board draws them on a phone, so there they take PhoneWeek.dc.html's and
   PhoneLibrary.dc.html's pieces: 16px gutters, cards with 14px corners and 20px 16px inside, the
   cards 1 column. Colours only from tokens.css; the board's faint grey is never used for small text
   (CLAUDE.md), so its small labels use the soft grey. Inside the frame's .pp--acc look (product.css),
   which sets the page, the gutter and the footer. */

.acc-home { display: flex; flex-direction: column; min-width: 0; }
.acc-loading { min-height: 50vh; }

/* The home's rows (Bands.jsx): the goal beside the next session, the 2 the same height; this month's
   actions beside the group and the wins, each its own height; 24px apart */
.acc-sections { display: flex; flex-direction: column; gap: 24px; min-width: 0; }
.acc-band { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 24px; align-items: start; }
.acc-band--single { grid-template-columns: minmax(0, 1fr); }
.acc-band--stretch { align-items: stretch; }
.acc-band-col { display: flex; flex-direction: column; gap: 24px; min-width: 0; }
.acc-band--stretch .acc-band-col > .acc-section:only-child { flex: 1; display: flex; flex-direction: column; }
.acc-band--stretch .acc-band-col > .acc-section:only-child > section { flex: 1; }
.acc-section { min-width: 0; }

/* Shared pieces */
.acc-card { border-radius: 14px; background: var(--acc-card); border: 1px solid var(--acc-rule); min-width: 0; }
.acc-eyebrow {
  margin: 0; font-size: 12px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; color: var(--acc-soft);
}
.acc-h2 { margin: 0; font-family: var(--acc-heading-font); font-weight: 700; font-size: 21px; line-height: 1.25; color: var(--acc-ink); }
.acc-h3 { margin: 0; font-family: var(--acc-heading-font); font-weight: 700; font-size: 17px; line-height: 1.3; color: var(--acc-ink); }
.acc-titles { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.acc-sub { font-size: 13px; line-height: 1.5; color: var(--acc-soft); }
.acc-count { font-size: 14px; font-weight: 600; color: var(--acc-green-2); white-space: nowrap; }
.acc-text { margin: 0; font-size: 15px; line-height: 1.6; color: var(--acc-soft); }
.acc-text--small { font-size: 14px; }
.acc-msg { margin: 0; font-size: 14px; line-height: 1.5; color: var(--acc-ink); }
.acc-row { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.acc-icon { fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.acc-btn {
  height: 40px; padding: 0 16px; border-radius: 9px; border: none; background: var(--acc-green); color: var(--on-dark);
  font-weight: 600; font-size: 14px; display: inline-flex; align-items: center; gap: 8px; white-space: nowrap;
}
.acc-btn-line {
  height: 40px; padding: 0 14px; border-radius: 9px; border: 1px solid var(--acc-rule); background: var(--acc-card);
  color: var(--acc-ink); font-weight: 600; font-size: 14px; display: inline-flex; align-items: center; white-space: nowrap;
}
.acc-btn--small { height: 34px; padding: 0 12px; border-radius: 8px; font-size: 13px; }
.acc-btn:disabled, .acc-btn-line:disabled { opacity: 0.6; }
.acc-link {
  align-self: flex-start; padding: 0; border: none; background: none; color: var(--acc-green); font-size: 14px; font-weight: 600;
  text-decoration: underline; text-underline-offset: 3px;
}
.acc-link:disabled { color: var(--acc-soft); }
.acc-card textarea, .acc-card input[type='text'], .acc-win-form input:not([type]) {
  font: inherit; color: var(--acc-ink); background: var(--acc-card); border: 1px solid var(--acc-rule);
}
.acc-card textarea::placeholder, .acc-card input::placeholder { color: var(--acc-soft); }
.pp--acc .acc-card :focus-visible { outline-color: var(--acc-green); }

/* Your goal */
.acc-goal { padding: 30px; display: flex; flex-direction: column; gap: 18px; }
.acc-goal-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.acc-goal-lock { display: flex; align-items: center; gap: 6px; font-size: 13px; color: var(--acc-soft); white-space: nowrap; }
.acc-goal-body {
  margin: 0; font-family: var(--acc-heading-font); font-weight: 600; font-size: 28px; line-height: 1.25;
  letter-spacing: -0.01em; color: var(--acc-ink); overflow-wrap: anywhere;
}
.acc-goal-intro { margin: 0; font-size: 16px; line-height: 1.6; color: var(--acc-soft); }
.acc-goal-form { display: flex; flex-direction: column; gap: 10px; }
.acc-goal-form textarea { min-height: 88px; padding: 10px 12px; border-radius: 9px; font-size: 16px; line-height: 1.5; resize: vertical; }
.acc-goal-change { align-self: flex-start; }

/* Under the goal (Adam, 18 Oct, 16:12): View your accountability log, a big button in the Accelerator's green the
   width of the goal, the 1 way into the log from the home; and when they're behind, the refocus card under it */
.acc-focus { display: flex; flex-direction: column; gap: 16px; margin-top: 16px; min-width: 0; }
.pp a.acc-log-btn, .acc-log-btn {
  display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; min-height: 58px; padding: 12px 20px;
  border-radius: 12px; background: var(--acc-green); color: var(--on-dark); font-family: var(--acc-heading-font);
  font-weight: 700; font-size: 18px; line-height: 1.3; text-align: center; text-decoration: none;
}
.acc-log-btn:hover { background: var(--acc-green-2); }
.pp--acc .acc-log-btn:focus-visible { outline: 3px solid var(--acc-green-2); outline-offset: 3px; }
.acc-refocus { padding: 26px 30px; display: flex; flex-direction: column; gap: 12px; border-left: 4px solid var(--acc-amber); }
.acc-refocus--well_behind { border-left-color: var(--acc-warn); background: var(--acc-warn-06); }
.acc-refocus-h { margin: 0; font-family: var(--acc-heading-font); font-weight: 700; font-size: 22px; line-height: 1.25; color: var(--acc-ink); }
.acc-refocus-goal { margin: 0; font-size: 17px; font-weight: 600; line-height: 1.5; color: var(--acc-ink); overflow-wrap: anywhere; }
.acc-refocus-only, .acc-refocus-help { margin: 0; font-size: 15px; line-height: 1.6; color: var(--acc-ink); }
.acc-refocus-facts { margin: 0; font-size: 15px; font-weight: 600; line-height: 1.5; color: var(--acc-pill-amber-ink); }
.acc-refocus--well_behind .acc-refocus-facts { color: var(--acc-warn); }
/* "See which in your log", to the first month with an action not done, and the actions carried into this month,
   named (the critique's member 6, 20 Oct) */
.pp a.acc-refocus-which, .acc-refocus-which { color: var(--acc-green); font-weight: 600; text-decoration: underline; text-underline-offset: 3px; white-space: nowrap; }
.acc-refocus-carried { margin: 0; font-size: 15px; line-height: 1.55; color: var(--acc-ink); overflow-wrap: anywhere; }
.acc-refocus-ask { padding-top: 12px; border-top: 1px solid var(--acc-rule); }
.acc-refocus-ask-h { margin: 0 0 6px; font-size: 15px; font-weight: 700; color: var(--acc-ink); }
.acc-refocus-asks { margin: 0; padding-left: 20px; display: flex; flex-direction: column; gap: 4px; font-size: 15px; line-height: 1.55; color: var(--acc-ink); }
.pp .acc-refocus-help a, .acc-refocus-help a { color: var(--acc-green); font-weight: 600; text-decoration: underline; text-underline-offset: 3px; overflow-wrap: anywhere; }
.mlog-refocus { margin: 0 0 24px; }
.acc-term { display: flex; flex-direction: column; gap: 10px; }
.acc-term-line { display: flex; justify-content: space-between; gap: 12px 20px; font-size: 14px; flex-wrap: wrap; }
.acc-term-month { font-weight: 600; color: var(--acc-ink); }
.acc-term-side { font-size: 14px; color: var(--acc-soft); }
.acc-term-bar { display: grid; grid-template-columns: repeat(12, minmax(0, 1fr)); gap: 5px; }
.acc-term-seg { height: 8px; border-radius: 4px; background: var(--acc-rule); }
.acc-term-seg--on { background: var(--acc-green); }

/* The next session: the green card */
.acc-next {
  padding: 30px; border-radius: 14px; background: var(--acc-green); color: var(--on-dark);
  display: flex; flex-direction: column; gap: 14px; min-width: 0;
}
.acc-next-eyebrow { margin: 0; font-size: 12px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; color: var(--on-dark-70); }
.acc-next-when { display: flex; flex-direction: column; gap: 4px; }
.acc-next-date { font-family: var(--acc-heading-font); font-weight: 700; font-size: 30px; line-height: 1.15; letter-spacing: -0.01em; }
.acc-next-line { font-size: 15px; color: var(--on-dark-80); }
.acc-next-none { margin: 0; font-size: 16px; line-height: 1.55; color: var(--on-dark-80); }
.acc-next-actions { display: flex; gap: 10px; flex-wrap: wrap; }
.acc-join {
  height: 40px; padding: 0 14px; border-radius: 9px; background: var(--on-dark-14); font-size: 14px; font-weight: 600;
  display: inline-flex; align-items: center; white-space: nowrap;
}
.pp .acc-join--open { background: var(--on-dark); color: var(--acc-green); text-decoration: none; }
.acc-cal {
  height: 40px; padding: 0 14px; border-radius: 9px; border: 1px solid var(--on-dark-45); background: transparent;
  color: var(--on-dark); font-weight: 600; font-size: 14px; white-space: nowrap;
}
.acc-next :focus-visible { outline-color: var(--on-dark); }
/* All sessions, and the latest session missed with its recording still to watch (the critique's members 5 and 9) */
.pp a.acc-next-all, .pp a.acc-next-watch { color: var(--on-dark); font-weight: 600; text-decoration: underline; text-underline-offset: 3px; }
.pp a.acc-next-all { align-self: flex-start; font-size: 14px; min-height: 32px; display: inline-flex; align-items: center; }
.acc-next-missed { margin: 0; font-size: 14px; line-height: 1.55; color: var(--on-dark); }
.acc-next-rule { height: 1px; background: var(--on-dark-18); margin: 4px 0; }
.acc-standing { display: flex; align-items: center; justify-content: space-between; gap: 10px 16px; flex-wrap: wrap; }
.acc-standing-line { font-size: 14px; }
.acc-pill {
  min-height: 26px; padding: 4px 10px; border-radius: 13px; background: var(--on-dark); color: var(--acc-green);
  font-size: 12px; font-weight: 700; line-height: 1.5; display: inline-flex; align-items: center;
}
a.acc-pill { text-decoration: none; min-height: 32px; }
/* as a link the pill keeps its own colour: .pp a would make it the card's white, on white */
.pp a.acc-pill { color: var(--acc-green); }
.pp a.acc-pill--getting_started { color: var(--on-dark); }
.pp a.acc-pill--a_little_behind, .pp a.acc-pill--behind { color: var(--acc-pill-amber-ink); }
.pp a.acc-pill--well_behind { color: var(--acc-pill-warn-ink); }
/* where they stand, from their accountability log: getting started an outline (the shape and the words carry it,
   never colour alone) */
/* the 3 levels of behind (src/products/mastermind/levels.js): never green; amber words on a light amber fill, bold
   and ringed for Behind, and the stronger warning, bold and ringed, for Well behind */
.acc-pill--a_little_behind { background: var(--acc-pill-amber-bg); color: var(--acc-pill-amber-ink); }
.acc-pill--behind { background: var(--acc-pill-amber-bg); color: var(--acc-pill-amber-ink); box-shadow: inset 0 0 0 2px var(--acc-pill-amber-ink); font-weight: 800; }
.acc-pill--well_behind { background: var(--acc-pill-warn-bg); color: var(--acc-pill-warn-ink); box-shadow: inset 0 0 0 2px var(--acc-pill-warn-ink); font-weight: 800; }
.acc-pill--getting_started { background: var(--on-dark-14); color: var(--on-dark); box-shadow: inset 0 0 0 1px var(--on-dark-45); }
.acc-next-note { margin: 0; font-size: 13px; line-height: 1.55; color: var(--on-dark-78); }

/* This month's actions */
.acc-actions { overflow: hidden; }
.acc-actions-head {
  padding: 22px 26px; display: flex; align-items: baseline; justify-content: space-between; gap: 16px;
  border-bottom: 1px solid var(--acc-rule);
}
/* how many are ticked, and when they're due (the critique's member 6) */
.acc-counts { display: flex; flex-direction: column; align-items: flex-end; gap: 2px; text-align: right; }
.acc-due { font-size: 13px; line-height: 1.45; color: var(--acc-soft); }
.acc-action { padding: 16px 26px; border-bottom: 1px solid var(--acc-rule); display: flex; flex-direction: column; gap: 10px; }
.acc-action-tick { display: flex; gap: 14px; align-items: flex-start; cursor: pointer; }
/* the board's tick box keeps the browser's own side margins (Accelerator.dc.html sets only its top) */
.acc-action-tick input { width: 19px; height: 19px; margin: 2px 3px 3px 4px; accent-color: var(--acc-green); flex-shrink: 0; }
.acc-action-body { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.acc-action-text { font-size: 15px; line-height: 1.5; color: var(--acc-ink); overflow-wrap: anywhere; }
.acc-action--done .acc-action-text { color: var(--acc-soft); text-decoration: line-through; }
.acc-badge {
  align-self: flex-start; min-height: 22px; padding: 2px 8px; border-radius: 11px; background: var(--acc-amber-08);
  color: var(--acc-amber); font-size: 12px; font-weight: 600; line-height: 1.5; display: inline-flex; align-items: center;
}
.acc-badge--to { background: var(--acc-green-08); color: var(--acc-green); }
.acc-badges { display: flex; flex-wrap: wrap; gap: 6px; }
.acc-actions-none { margin: 0; padding: 18px 26px; font-size: 15px; line-height: 1.55; color: var(--acc-soft); border-bottom: 1px solid var(--acc-rule); }
.acc-actions-msg { padding: 12px 26px 0; }
.acc-actions-foot { margin: 0; padding: 16px 26px 20px; font-size: 14px; line-height: 1.6; color: var(--acc-soft); }

/* A member's note on an action (the Actions page) */
.acc-note { display: flex; flex-direction: column; gap: 6px; padding-left: 40px; }
.acc-note-text { margin: 0; font-size: 14px; line-height: 1.55; color: var(--acc-ink); overflow-wrap: anywhere; }
.acc-note-label { display: block; font-size: 12px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; color: var(--acc-soft); margin-bottom: 2px; }
.acc-note-form { display: flex; flex-direction: column; gap: 10px; padding-left: 40px; }
.acc-note-form textarea { min-height: 76px; padding: 10px 12px; border-radius: 8px; font-size: 14px; line-height: 1.5; resize: vertical; }

/* The Actions page's past months: 1 line pointing to the log (member 7) */
.acc-past-list { display: flex; flex-direction: column; gap: 10px; }
.pp .acc-text-link { color: var(--acc-green); font-weight: 600; text-decoration: underline; text-underline-offset: 3px; }

/* Your group */
.acc-group { padding: 24px 26px; display: flex; flex-direction: column; gap: 12px; }
.acc-wa {
  align-self: flex-start; min-height: 42px; padding: 0 16px; border-radius: 9px; background: var(--acc-green);
  font-weight: 600; font-size: 14px; display: inline-flex; align-items: center; gap: 8px; text-decoration: none;
}
.pp .acc-wa { color: var(--on-dark); }

/* Your wins */
.acc-wins { padding: 24px 26px; display: flex; flex-direction: column; gap: 14px; }
.acc-wins-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.acc-win-form {
  display: flex; flex-direction: column; gap: 10px; padding: 14px; border-radius: 10px; background: var(--acc-bg);
  border: 1px solid var(--acc-rule);
}
.acc-win-form input:not([type]) { height: 40px; padding: 0 12px; border-radius: 8px; font-size: 14px; }
/* More about it (Adam's yes of 11 Oct): a box under the words, as long as the member needs */
.acc-win-form textarea { min-height: 72px; padding: 10px 12px; border-radius: 8px; font-size: 14px; line-height: 1.5; resize: vertical; }
.acc-win-form .acc-btn { align-self: flex-start; }
.acc-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.acc-chip {
  height: 30px; padding: 0 11px; border-radius: 15px; border: 1px solid var(--acc-rule); background: var(--acc-card);
  color: var(--acc-ink); font-size: 13px; font-weight: 500;
}
.acc-chip:hover { border-color: var(--acc-green-2); }
.acc-chip--on, .acc-chip--on:hover { background: var(--acc-green); border-color: var(--acc-green); color: var(--on-dark); }
.acc-share { display: flex; gap: 10px; align-items: flex-start; font-size: 14px; line-height: 1.5; color: var(--acc-ink); cursor: pointer; }
.acc-share input { width: 18px; height: 18px; margin: 1px 0 0; accent-color: var(--acc-green); flex-shrink: 0; }
.acc-win-list { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 14px; }
.acc-win { display: flex; gap: 12px; align-items: flex-start; }
.acc-win-tick {
  width: 30px; height: 30px; border-radius: 15px; background: var(--acc-green-08); color: var(--acc-green-2);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.acc-win-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.acc-win-title { font-size: 15px; font-weight: 500; line-height: 1.45; color: var(--acc-ink); overflow-wrap: anywhere; }
.acc-win-meta { font-size: 13px; color: var(--acc-soft); }
/* a win's More about it, under its kind and date: kept whole, with the line breaks it was typed with */
.acc-win-detail { margin-top: 4px; font-size: 14px; line-height: 1.55; color: var(--acc-soft); white-space: pre-line; overflow-wrap: anywhere; }
/* Edit on their own win (undrawn): a quiet text button at the row's end, then the form in its place */
.acc-win-edit {
  margin-left: auto; flex-shrink: 0; min-height: 30px; padding: 0 2px; border: none; background: none; color: var(--acc-green);
  font-size: 13px; font-weight: 600; text-decoration: underline; text-underline-offset: 3px;
}
.acc-win-edit:disabled { color: var(--acc-soft); }
.acc-win--editing { display: block; }
/* a win staff logged (Adam, 7 Oct): no Edit, only its share tick, changed in place under its line */
.acc-win-share { margin-top: 6px; font-size: 13px; gap: 8px; }
.acc-win-share input { width: 16px; height: 16px; margin: 2px 0 0; }
.acc-win-share:has(input:disabled) { cursor: default; }
.acc-win-text .acc-msg { margin-top: 4px; font-size: 13px; }
.acc-win-confirm { display: flex; flex-direction: column; gap: 10px; }
.acc-said { margin: 0; font-size: 14px; line-height: 1.5; color: var(--acc-green-2); }
.acc-wins-all { min-height: 32px; }

/* The home's latest recording (LatestRecording.jsx) and its Resources shortcuts (Shelf.jsx ResourceShortcuts): the
   critique's member 5, 20 Oct */
.acc-latest-head {
  padding: 22px 26px 18px; display: flex; align-items: center; justify-content: space-between; gap: 16px;
  border-bottom: 1px solid var(--pp-rule);
}
.pp a.acc-latest-all { text-decoration: none; color: var(--acc-ink); }
.acc-shortcuts { padding: 24px 26px; display: flex; flex-direction: column; gap: 14px; }
.acc-shortcut-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.pp a.acc-shortcut {
  display: flex; align-items: center; justify-content: space-between; gap: 10px; min-height: 52px; padding: 12px 16px;
  border-radius: 10px; border: 1px solid var(--acc-rule); background: var(--acc-card); color: var(--acc-ink);
  font-weight: 600; font-size: 15px; text-decoration: none; min-width: 0;
}
.pp a.acc-shortcut:hover { border-color: var(--acc-green-2); }
.acc-shortcut-name { min-width: 0; overflow-wrap: anywhere; }
.acc-shortcut-count { font-weight: 500; color: var(--acc-soft); }

/* The Resources shelf: the board's sizes over the shared Resources' class names (Shelf.jsx) */
.acc-shelf { border-radius: 14px; background: var(--acc-card); border: 1px solid var(--acc-rule); overflow: hidden; min-width: 0; }
.acc-shelf-head {
  padding: 22px 26px 0; display: flex; align-items: flex-end; justify-content: space-between; gap: 24px;
  border-bottom: 1px solid var(--acc-rule);
}
.acc-shelf-titles { display: flex; flex-direction: column; gap: 12px; min-width: 0; }
.acc-shelf-h { margin: 0; font-family: var(--acc-heading-font); font-weight: 700; font-size: 21px; color: var(--acc-ink); }
.acc-shelf--page .acc-shelf-h { font-size: 40px; line-height: 1.1; letter-spacing: -0.01em; }
/* the tabs wrap onto the next line where they don't all fit, as Resources' tabs do (resources.css) */
.acc-shelf-tabs { display: flex; flex-wrap: wrap; column-gap: 26px; row-gap: 4px; overflow-x: auto; scrollbar-width: none; }
.acc-shelf-tabs::-webkit-scrollbar { display: none; }
.acc-shelf .acc-tab {
  padding: 8px 0 12px; border: none; border-bottom: 2px solid transparent; background: none; color: var(--acc-soft);
  font-weight: 600; font-size: 14px; display: flex; gap: 6px; align-items: center; white-space: nowrap;
}
.acc-shelf .acc-tab--on { border-bottom-color: var(--acc-green); color: var(--acc-ink); }
.acc-tab-count { font-weight: 500; color: var(--acc-soft); }
.pp .acc-terms { padding-bottom: 14px; font-size: 14px; color: var(--acc-soft); text-decoration: underline; text-underline-offset: 2px; white-space: nowrap; flex-shrink: 0; }
.acc-shelf-note { margin: 0; padding: 16px 26px 0; font-size: 14px; line-height: 1.5; color: var(--acc-soft); }
.acc-shelf-video { padding: 22px 26px 0; }
.acc-shelf-video .pp-res-line { text-align: left; max-width: none; font-size: 14px; }
.acc-shelf-grid { padding: 22px 26px 26px; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.acc-shelf .acc-res {
  display: flex; flex-direction: row; align-items: center; justify-content: flex-start; gap: 12px; padding: 14px 16px; border-radius: 10px;
  border: 1px solid var(--acc-rule); background: var(--acc-card); color: var(--acc-ink); text-decoration: none; text-align: left;
  font: inherit; width: 100%; min-width: 0;
}
.pp .acc-shelf .acc-res { color: var(--acc-ink); }
.acc-shelf a.acc-res:hover, .acc-shelf button.acc-res:hover, .acc-shelf .acc-res--on { border-color: var(--acc-green-2); }
.acc-res--locked { opacity: 0.8; }
.acc-res-icon {
  width: 34px; height: 34px; border-radius: 8px; background: var(--acc-green-08); color: var(--acc-green);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.acc-res-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.acc-shelf .acc-res-title { font-family: var(--acc-body-font); font-size: 14px; font-weight: 600; line-height: 1.35; color: var(--acc-ink); }
.acc-shelf .acc-res-meta { font-size: 12px; line-height: 1.45; color: var(--acc-soft); }
.acc-shelf .acc-res-meta--new { color: var(--acc-green-2); font-weight: 400; }
.acc-res-life { font-size: 12px; font-weight: 600; color: var(--acc-green); }
.acc-res-line { font-size: 12px; line-height: 1.45; color: var(--acc-ink); }
.acc-shelf .acc-shelf-foot { margin: 0; padding: 0 26px 22px; font-size: 13px; line-height: 1.5; color: var(--acc-soft); }

/* The Actions and Group pages */
.acc-page { display: flex; flex-direction: column; gap: 28px; min-width: 0; }
.acc-page .acc-actions, .acc-page .acc-group, .acc-page .acc-dir, .acc-page .acc-past-list { max-width: 960px; }

/* The member directory (the Group page) */
.acc-dir { padding: 24px 26px; display: flex; flex-direction: column; gap: 16px; }
.acc-dir-nudge { margin: 0; padding: 12px 14px; border-radius: 10px; background: var(--acc-bg); border: 1px solid var(--acc-rule); font-size: 14px; line-height: 1.55; color: var(--acc-ink); }
.pp .acc-dir-nudge a { color: var(--acc-green); font-weight: 600; }
.acc-dir-failed { display: flex; flex-direction: column; gap: 10px; align-items: flex-start; }
.acc-dir-list { margin: 0; padding: 0; list-style: none; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.acc-person {
  display: flex; gap: 14px; align-items: flex-start; padding: 16px; border-radius: 12px; border: 1px solid var(--acc-rule);
  background: var(--acc-card); min-width: 0;
}
.acc-avatar {
  width: 48px; height: 48px; border-radius: 24px; border: 1.5px solid var(--acc-green); color: var(--acc-green);
  display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 16px; flex-shrink: 0; overflow: hidden;
}
.acc-avatar img { width: 100%; height: 100%; object-fit: cover; }
.acc-person-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.acc-person-name { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; font-family: var(--acc-heading-font); font-size: 16px; font-weight: 600; color: var(--acc-ink); }
.acc-you {
  height: 20px; padding: 0 8px; border-radius: 10px; background: var(--acc-green-08); color: var(--acc-green);
  font-family: var(--acc-body-font); font-size: 12px; font-weight: 600; display: inline-flex; align-items: center;
}
.acc-person-group { font-size: 13px; font-weight: 600; color: var(--acc-green-2); }
.acc-person-loc { font-size: 14px; color: var(--acc-soft); }
.acc-person-about { font-size: 14px; line-height: 1.55; color: var(--acc-ink); overflow-wrap: anywhere; }

/* Between a laptop and a phone: every section 1 column (Bands.jsx), the shelf 2 to a row */
@media (max-width: 1099px) {
  .acc-shelf-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

/* A phone */
@media (max-width: 760px) {
  .acc-sections { gap: 22px; }
  .acc-goal, .acc-next { padding: 20px 16px; gap: 14px; }
  .acc-focus { gap: 14px; margin-top: 14px; }
  .acc-log-btn { min-height: 54px; font-size: 17px; }
  .acc-refocus { padding: 20px 16px; }
  .acc-refocus-h { font-size: 20px; }
  .acc-goal-body { font-size: 22px; }
  .acc-next-date { font-size: 26px; }
  .acc-next-actions { flex-direction: column; align-items: stretch; }
  .acc-join, .acc-cal { justify-content: center; height: 44px; }
  .acc-actions-head { padding: 18px 16px; flex-direction: column; align-items: flex-start; gap: 8px; }
  .acc-counts { align-items: flex-start; text-align: left; }
  .acc-action { padding: 14px 16px; }
  .acc-action-tick input { width: 22px; height: 22px; margin: 0; }
  .acc-note, .acc-note-form { padding-left: 36px; }
  .acc-actions-none { padding: 16px; }
  .acc-actions-msg { padding: 12px 16px 0; }
  .acc-actions-foot { padding: 14px 16px 18px; }
  .acc-group, .acc-wins, .acc-dir { padding: 20px 16px; }
  .acc-wa { align-self: stretch; justify-content: center; min-height: 44px; }
  .acc-chip { height: 36px; padding: 0 14px; }
  .acc-win-edit { min-height: 36px; }
  .acc-win-share { min-height: 36px; align-items: center; margin-top: 2px; }
  .acc-win-share input { width: 22px; height: 22px; margin: 0; }
  .acc-shelf-head { padding: 18px 16px 0; }
  .acc-shelf--page .acc-shelf-h { font-size: 30px; }
  .acc-shelf-tabs { column-gap: 22px; }
  .pp .acc-terms--phone { display: block; padding: 14px 16px 0; white-space: normal; }
  .acc-shelf-note { padding: 14px 16px 0; }
  .acc-shelf-video { padding: 16px 16px 0; }
  .acc-shelf-grid { grid-template-columns: minmax(0, 1fr); padding: 16px; gap: 10px; }
  .acc-shelf .acc-shelf-foot { padding: 0 16px 18px; }
  .acc-dir-list { grid-template-columns: minmax(0, 1fr); }
  .acc-page { gap: 22px; }
  .acc-latest-head { padding: 18px 16px 16px; }
  .acc-shortcuts { padding: 20px 16px; }
  .acc-shortcut-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
  .pp a.acc-next-all { min-height: 44px; }
}
